import { ApplicationPageProps } from "../../Application";
import { ApplicationBackground } from "../../ApplicationBackground";
import { FormsCheckBox, FormsInputDropdown, InputDropdownItem } from "@platform/components";
import { ApplicationPageContent } from "../../components/ApplicationPageContent";
import BackgroundImage from '../../images/Aanu-Gopald.svg';
import { ProfessionalApplicationParameters } from "@platform/client/schemas";
import { useApplicationLocalStorage } from "../../application-hook";
import { SubmitHandler, useForm } from "react-hook-form";
import { ReactNode } from "react";

type FormValues = {
	referralMethod: string;
	commit: boolean;
};

export const ReferralSelection = (props: ApplicationPageProps & {
	referralOptions: InputDropdownItem[];
	programTermsText?: string | ReactNode;
	programTermsErrorText?: string;
}) => {
	const { onBack, onContinue, progress, dataKey, referralOptions, programTermsText, programTermsErrorText } = { ...props };
	const { updateApplicationData, getApplicationDataByKey } =
		useApplicationLocalStorage<ProfessionalApplicationParameters>(dataKey);
	const {
		handleSubmit,
		control,
		formState: { errors },
	} = useForm<FormValues>({
		mode: 'onBlur',
		reValidateMode: 'onChange',
		defaultValues: {
			commit: false,
			referralMethod: getApplicationDataByKey('referralMethod') || '',
		},
	});

	const onSubmit: SubmitHandler<FormValues> = (data) => {
		updateApplicationData({
			referralMethod: data.referralMethod,
		});
		onContinue();
	}

	return (
		<ApplicationBackground
			progress={progress}
			onBack={onBack}
			onSubmit={handleSubmit(onSubmit)}
			backgroundImage={BackgroundImage}
		>
			<ApplicationPageContent
				title="You're almost there"
				description="Just one more question, then you'll review your timeline and submit. Responses are final after that."
			>
				<FormsInputDropdown
					control={control}
					name='referralMethod'
					label='How did you find out about this opportunity?'
					placeholder='Select one'
					items={referralOptions}
					type='default'
					rules={{ required: 'Tell us how you heard about this opportunity to continue' }}
					error={errors.referralMethod}
					inputDisabled={true}
				/>
				{programTermsText && <FormsCheckBox
					control={control}
					name='commit'
					size='md'
					description={
						<>
							{programTermsText}
						</>
					}
					rules={{ required: programTermsErrorText || 'Agree to the program requirements checkbox to continue' }}
				/>}
			</ApplicationPageContent>
		</ApplicationBackground>
	)
}